import { createFileRoute } from '@tanstack/react-router'
import { ReleaseNotesPage } from '@/components/ReleaseNotes/ReleaseNotesPage'

export const Route = createFileRoute('/updates/$slug')({
  component: () => {
    const { slug } = Route.useParams()
    return <ReleaseNotesPage scrollToSlug={slug} />
  },
})
